module.exports = __webpack_public_path__ + "static/media/icon_action_tel.73f27d23.svg";